module.exports = __webpack_public_path__ + "img/angle-brackets.79eed5d2.svg";